import CryptoJS from 'crypto-js'

// 生成 AESKEY
export const aesKey = genRandomHexStr(16)

/**
 * 获取指定长度随机字符串
 * @param length{number} 字符串长度
 * @returns {string}
 */
export function genRandomHexStr(length) {
    let text = ''
    let possible = '0123456789abcdef'
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
}

function GetAesKey(keyArray) {
    var newArray = "";
    if (keyArray.length >= 16) return keyArray
    for (let i = 0; i < 16; i++) {
        if (i >= keyArray.length) {
            newArray = newArray + "0"
        } else {
            newArray = newArray + keyArray[i]
        }
    }
    return newArray
}

/**
 * AES 加密
 * @param word{string} 待加密字段
 * @param keyStr{string} 加密 key
 * @param autoHandle{boolean} 是否自动补全到至少16位
 * @returns {string} 返回加密字段
 */
export function aesEncrypt(word, keyStr, autoHandle = true) {
    keyStr = keyStr || aesKey
    if (autoHandle) keyStr = GetAesKey(keyStr)
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    let srcs = ''
    switch (typeof (word)) {
        case 'string':
            srcs = CryptoJS.enc.Utf8.parse(word)
            break
        case 'object':
            srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(word))
            break
        default:
            srcs = CryptoJS.enc.Utf8.parse(word.toString())
    }
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})// {iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})
    return encrypted.toString()
}

/**
 * AES 解密
 * @param word{string} 待解密数据
 * @param keyStr{string} 解密 key
 * @param autoHandle{boolean} 是否自动补全到至少16位
 * @returns {string} 返回解密字符串
 */
export function aesDecrypt(word, keyStr, autoHandle = true) {
    keyStr = keyStr || aesKey
    if (autoHandle) keyStr = GetAesKey(keyStr)
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    const decrypt = CryptoJS.AES.decrypt(word, key, {iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})// {iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}



// WEBPACK FOOTER //
// ./src/security/AesHelper.js